import { faPercent } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { CSSProperties } from "react";
import { hasValue } from "Tools";
import { SimpleFieldProps, withFieldValueConverter } from "./FormTools";
import { Textbox } from "./Textbox";
import { YupDefined } from "./Tools";

export function PercentInput({
  integerScale = 8,
  decimalScale = 0,
  ...props
}: {
  fieldProps: SimpleFieldProps<number | null>;
  placeholder?: string;
  integerScale?: number;
  decimalScale?: number;
  style?: CSSProperties;
  isDisabled?: boolean;
}) {
  return (
    <Textbox
      fieldProps={withFieldValueConverter(props.fieldProps, {
        parse: e => {
          if (!hasValue(e)) {
            return null;
          }
          const value = parseFloat(e);
          if (isNaN(value)) {
            return null;
          }
          const [integer, decimalOrUndefined] = value.toString().split(".");
          const decimal = (decimalOrUndefined as string | undefined) ?? "";
          // NOTE: divides by 100 without rounding by moving the decimal point
          // prevents the situation of parseFloat("29.36") / 100 !== parseFloat("0.2936")
          return parseFloat(
            `${integer.slice(0, -2)}.${integer
              .slice(-2)
              .padStart(2, "0")}${decimal}`,
          );
        },
        format: e => (e !== null ? (100 * e).toFixed(decimalScale) : null),
      })}
      rightIconContent={<FontAwesomeIcon icon={faPercent} />}
      cleaveOptions={{
        numeral: true,
        numeralIntegerScale: integerScale,
        numeralDecimalScale: decimalScale,
        numeralPositiveOnly: true,
      }}
      isDisabled={props.isDisabled}
      style={{ ...props.style }}
    />
  );
}

PercentInput.getDefaultValidator = () =>
  YupDefined.number().nullable().positive();
